import DAO from './DAO.js';
import ReduxConstants from '../constants/ReduxConstants.js';
import { RecordStates } from '../constants/ReduxConstants.js';
import dataModel from '../models/DataModel';

export default class CollectionsDAO extends DAO {

  constructor(store) {
    super(store);
    this.unsetCollection = this.unsetCollection.bind(this);
    this.clearCollections = this.clearCollections.bind(this);
    this.getAllCollections = this.getAllCollections.bind(this);
    this.setRawCollection = this.setRawCollection.bind(this);
    this.getCollectionsByType = this.getCollectionsByType.bind(this);
    this.handleCollectionActionCable = this.handleCollectionActionCable.bind(this);
    this.handleActionCableProjectCollections = this.handleActionCableProjectCollections.bind(this);
    this.handleActionCableBuildCollections = this.handleActionCableBuildCollections.bind(this);
    this.handleActionCableTaskCollections = this.handleActionCableTaskCollections.bind(this);
    this.handleActionCableLocationCollections = this.handleActionCableLocationCollections.bind(this);
    this.handleActionCableProjectTypeCollections = this.handleActionCableProjectTypeCollections.bind(this);
    this.handleActionCableCloseoutCollections = this.handleActionCableCloseoutCollections.bind(this);
    this.handleActionCableCompanyCollections = this.handleActionCableCompanyCollections.bind(this);
    this.handleActionCableMarketCollections = this.handleActionCableMarketCollections.bind(this);
    this.markCollectionNeedsSync = this.markCollectionNeedsSync.bind(this);
  }

  setCollectionAction(key, collection){
    return {
      type: 'COLLECTION_SET',
      key: key,
      collection: collection,
    };
  }

  unsetCollectionAction(key) {
    return {
      type: 'COLLECTION_UNSET',
      key: key,
    };
  }

  clearCollectionsAction() {
    return {
      type: 'COLLECTION_CLEAR',
    };
  }
  
  findCollection(key) {
    return this.stateTree.collections[key];
  }

  getCollections() {
    return this.stateTree.collections;
  }

  getCollectionsByType(collectionType, subKey) {
    let collections = [];
    for (let key in this.stateTree.collections){
      if (key && this.stateTree.collections[key] && this.stateTree.collections[key].collectionType == collectionType && (!subKey || (subKey && key.indexOf(subKey))) >= 0){
        collections.push(key);
      }
    }
    return collections;
  }

  getAllCollections() {
    let collections = [];
    for (let key in this.stateTree.collections) {
      if (key) {
        collections.push(key);
      }
    }
    return collections;
  }

  setCollection(key, collectionData, collectionType) {
    collectionData.collectionType = collectionType;
    this.store.dispatch(this.setCollectionAction(key, collectionData));
    return this.findCollection(key);
  }

  setRawCollection(key, collectionData) {
    this.setCollection(key, collectionData, collectionData.collectionType);
  }

  unsetCollection(key) {
    this.store.dispatch(this.unsetCollectionAction(key));
  }

  clearCollections() {
    this.store.dispatch(this.clearCollectionsAction());
  }

  markCollectionNeedsSync(collectionIds, checkItemPresence, deleteId, collectionsOnly) {
    if (!collectionIds) {
      collectionIds = this.getAllCollections();
      dataModel.tasksDAO.markTasksNeedsSync();
      dataModel.completionCriteriaDAO.markCompletionCriteriaNeedsSync();
    }
    if (collectionIds){
      for (let i = 0; i < collectionIds.length; i++) {
        let collection  = this.findCollection(collectionIds[i]);
        if (collection && collection.collectionType != 'offlineQueue') {
          let markIt = true;
          if (checkItemPresence) {
            markIt = collection.ids ? collection.ids.find(id => { return id == +deleteId; }) : true;
          }
          if (markIt) {
            collection._recordState = RecordStates.NEEDS_SYNC;
            this.setCollection(collectionIds[i], collection, collection.collectionType);
          }
        }
      }
    }
  }

  handleActionCableProjectCollections(acData) {
    if (acData.type == 'updateProject' || acData.type == 'updateProjectMemberAssignments' || acData.type == 'updateProjectForLocation') {
      switch (acData.sub_type) {
      case 'step_create':
      case 'task_create':
        this.markCollectionNeedsSync(this.getCollectionsByType(ReduxConstants.PROJECT), true, acData.project_id);
        break;
      case 'step_delete':
      case 'task_delete':
      case 'task_copy':
        this.markCollectionNeedsSync(this.getCollectionsByType(ReduxConstants.PROJECT), true, acData.project_id);
        break;
      case 'member_assignments':
      case 'task_assignments':
      case 'change_favorite':
      case 'bulk_assign':
        this.markCollectionNeedsSync(this.getCollectionsByType(ReduxConstants.PROJECT), false);
        break;
      default:
        break;
      }
    }
    else if (acData.type == 'deleteProject' || acData.type == 'deleteProjectForLocation') {
      this.markCollectionNeedsSync(this.getCollectionsByType(ReduxConstants.PROJECT), true, acData.project_id);
    }
    else if (acData.type == 'newProject') {
      this.markCollectionNeedsSync(this.getCollectionsByType(ReduxConstants.PROJECT), false);
    }
  }

  handleActionCableBuildCollections(acData) {
    
  }

  handleActionCableTaskCollections(acData) {
    if (acData.type == 'updateTask' || acData.type == 'updateTaskAssignments') {
      switch (acData.sub_type) {
      case 'step_update':
      case 'step_delete':
      case 'step_create':
      case 'task_update':
      case 'task_create':
      case 'task_delete':
      case 'task_assignments':
      case 'bulk_assign':
        this.markCollectionNeedsSync(this.getCollectionsByType(ReduxConstants.TASK), false);
        break;
      default:
        break;
      }
    }
    else if (acData.type == 'createRDL' && acData.sub_type == 'replaceRDL') {
      this.markCollectionNeedsSync(this.getCollectionsByType(ReduxConstants.TASK), false);
    }
    if (acData.project_type_id || acData.project_template_id) {
      this.markCollectionNeedsSync(this.getCollectionsByType(ReduxConstants.PROJECT_TYPE));
    }
  }

  handleActionCableLocationCollections(acData) {
    if (acData.type == 'newLocation' || acData.type == 'deleteLocation') {
      this.markCollectionNeedsSync(this.getCollectionsByType(ReduxConstants.LOCATION), acData.type == 'deleteLocation', acData.location_id);
    }
  }

  handleActionCableCompanyCollections(acData) {
    if (acData.type == 'newCompany' || acData.type == 'deleteCompany') {
      this.markCollectionNeedsSync(this.getCollectionsByType(ReduxConstants.COMPANY), acData.type == 'deleteCompany', acData.company_id);
    }
  }

  handleActionCableMarketCollections(acData) {
    if (acData.type == 'createMarket' || acData.type == 'updateMarket' || acData.type == 'deleteMarket') {
      // Invalidate every cached Markets list (keyed per company/user) so pages
      // like Plan of Record and Project Types & Templates refetch and pick up
      // the change on their next fetch, instead of serving a stale SYNCED cache.
      this.markCollectionNeedsSync(this.getCollectionsByType(ReduxConstants.MARKET));
    }
  }

  handleActionCableProjectTypeCollections(acData) {
    this.markCollectionNeedsSync(this.getCollectionsByType(ReduxConstants.PROJECT_TYPE), acData.type == 'deleteProjectType', acData.project_type_id);
  }

  handleActionCableCloseoutCollections(acData) {
    this.markCollectionNeedsSync(this.getCollectionsByType(ReduxConstants.CLOSEOUT), true, acData.closeout_id);
  }

  handleActionCableUserCollections(acData) {
    this.markCollectionNeedsSync(this.getCollectionsByType(ReduxConstants.USER), true, acData.user_id);
  }

  handleCollectionActionCable(acData) {
    const updateType = acData.type.toLowerCase();
    if (updateType.includes('projecttype')) {
      this.handleActionCableProjectTypeCollections(acData);
    }
    else if (updateType.includes('project')) {
      this.handleActionCableProjectCollections(acData);
    }
    else if (updateType.includes('task')) {
      this.handleActionCableTaskCollections(acData);
    }
    else if (updateType.includes('location')){
      this.handleActionCableLocationCollections(acData);
    }
    else if (updateType.includes('company')){
      this.handleActionCableCompanyCollections(acData);
    }
    else if (updateType.includes('market')){
      this.handleActionCableMarketCollections(acData);
    }
    else if (acData.type == 'createRDL') {
      this.handleActionCableTaskCollections(acData);
    }
    else if (updateType.includes('closeout')) {
      this.handleActionCableCloseoutCollections(acData);
    }
    else if (updateType.includes('user')) {
      this.handleActionCableUserCollections(acData);
    }
  }

  clearState(options) {
    if (options && options.clearOfflineQueue) {
      this.clearCollections();
    } 
    else if (this.stateTree.collections) {
      for (const key of Object.keys(this.stateTree.collections)) {
        if (key != dataModel.offlineQueue.getKey() && (key.toLowerCase().indexOf('companies') < 0 || (options && options.newSpaVersion))) {
          this.unsetCollection(key);
        }
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/dao/CollectionsDAO.js